export const getBaseUrl = (url) => {
  let paths = url.split('/');
  let basePaths = paths.slice(0, 3);

  return basePaths.join('/');
}

export const isNumber = (n) => {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function* chunks(arr, n) {
  for (let i = 0; i < arr.length; i += n) {
    yield arr.slice(i, i + n);
  }
}

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

export const padNumber = (number = 0, pad) => {
  const length = pad - String(number).length + 1;
  let padding = '';
  if (length > 0) {
    padding = Array(pad - String(number).length + 1).join('0');
  }
  return padding + number;
}